import React, { useState, useEffect } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons'
import { Spinner } from 'react-bootstrap'
import { baseURL } from '../Network/Config'
import "./ImagePreview.css"

const ImagePreview = ({ imagesSet, initialKey, isGetBaseURL }) =>{
    const [key, setKey] = useState(initialKey)
    const [isShowNav, setShowNav] = useState(false)
    const [isLoadImage, setLoadingImage] = useState(false)
    const images = imagesSet || []

    useEffect(()=>{
        setLoadingImage(true)
        setKey(initialKey)
    },[])

    return(
        <div 
        className="image-preview"
        onMouseOver={()=>{ 
            setShowNav(true)
        }}
        onMouseLeave={()=>{
            setShowNav(false)
        }}>
            { isShowNav ?
            <>
                { key > 0 ?
                <div className="nav-btn nav-btn-left"
                onClick={()=>{
                    setLoadingImage(true)
                    setKey(key - 1)
                }}>
                    <FontAwesomeIcon icon={faChevronLeft}/>
                </div>
                : null
                }
                { key < images.length - 1 ?
                <div className="nav-btn nav-btn-right"
                onClick={()=>{
                    setLoadingImage(true)
                    setKey(key + 1)
                }}>
                    <FontAwesomeIcon icon={faChevronRight}/>
                </div>
                : null
                }
            </>
            : null
            }
            <img src={ isGetBaseURL ? baseURL + images[key]?.imagePath : images[key]?.imagePath}
            style={{width: "100%", height: "100%"}}
            onLoad={()=>setLoadingImage(false)}
            loading="lazy"
            />

            { isLoadImage ?
            <Spinner
            className="load-spinner"
            animation="border"
            />
            : null
            }
        </div>
    )
}

export default ImagePreview